import React from "react";

function Highlighter({ children }) {
  return (
    <span className=" text-white-400 font-bold px-1 py-1">{children}</span>
  );
}

export default Highlighter;
